'use client';

import React, { ReactNode, createContext, useCallback, useContext, useState } from 'react';

import { useThemeLoader } from '@/hooks/useThemeLoader';
import { logger } from '@/lib/logger';

/**
 * Loading Context and Hook
 * Manages global loading state with theme-aware loader
 */

/**
 * Loading Context and Hook
 * Manages global loading state with theme-aware loader
 */

/**
 * Loading Context and Hook
 * Manages global loading state with theme-aware loader
 */

/**
 * Loading Context and Hook
 * Manages global loading state with theme-aware loader
 */

/**
 * Loading Context and Hook
 * Manages global loading state with theme-aware loader
 */

interface LoadingContextValue {
  isLoading: boolean;
  message?: string;
  setLoading: (loading: boolean, message?: string) => void;
  withLoading: <T>(fn: () => Promise<T>, message?: string) => Promise<T>;
}

const LoadingContext = createContext<LoadingContextValue | undefined>(undefined);

export function LoadingProvider({ children }: { children: ReactNode }) {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<string | undefined>();
  const LoaderComponent = useThemeLoader();

  const setLoading = useCallback((loading: boolean, msg?: string) => {
    setIsLoading(loading);
    setMessage(msg);
    logger.debug({ msg: `Loading state changed`, loading, message: msg });
  }, []);

  const withLoading = useCallback(
    async <T,>(fn: () => Promise<T>, msg?: string): Promise<T> => {
      setLoading(true, msg);
      try {
        const result = await fn();
        return result;
      } finally {
        setLoading(false);
      }
    },
    [setLoading],
  );

  return (
    <LoadingContext.Provider value={{ isLoading, message, setLoading, withLoading }}>
      {children}
      {isLoading && <LoaderComponent fullScreen message={message} />}
    </LoadingContext.Provider>
  );
}

export function useLoading() {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within LoadingProvider');
  }
  return context;
}
